import script from "./BrandFieldsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandFieldsForm.vue?vue&type=script&setup=true&lang=js"

import "./BrandFieldsForm.vue?vue&type=style&index=0&id=212bcbda&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-212bcbda"]])

export default __exports__